<template>

  <!-- 正在支付中时，页面上渲染一个转圈 -->
  <div v-if="paying">
    <PageLoading />
  </div>


  <nav>
    <div class="container">
      <div class="logo">
        <img src="/logo.svg" alt="SmartReader Logo" width="40" height="40" />
        <span>SmartReader</span>
      </div>
      <ul>
        <li><a href="#features">Features</a></li>
        <li><a href="#how-it-works">How it Works</a></li>
        <li><a href="#pricing">Pricing</a></li>
      </ul>
    </div>
  </nav>

  <section class="hero">
    <div class="container">
      <h1>Revolutionize Your RSS Reading Experience</h1>
      <p>
        Harness the power of AI to filter, summarize, and visualize your RSS
        feeds.
      </p>
      <div class="main-cta-button" @click="goToSignIn">
        <div class="primary-text">Get Started</div>
        <div class="secondary-text">It's free</div>
      </div>
    </div>
  </section>

  <section id="features" class="features">
    <div class="container">
      <h2>Powerful Features</h2>
      <div class="features-grid">
        <div class="feature-card">
          <img src="https://img.icons8.com/pulsar-color/96/filter.png" alt="AI Filtering" />
          <h3>AI Smart Filtering</h3>
          <p>Customize your content feed with intelligent filtering</p>
        </div>
        <div class="feature-card">
          <img src="https://img.icons8.com/pulsar-color/96/brief.png" alt="Smart Summaries" />
          <h3>Intelligent Summaries</h3>
          <p>Get the gist of articles with AI-powered summaries</p>
        </div>
        <div class="feature-card">
          <img src="https://img.icons8.com/pulsar-color/96/light-on.png" alt="Keyword Extraction" />
          <h3>Key Insights</h3>
          <p>Extract essential keywords and core ideas effortlessly</p>
        </div>
        <div class="feature-card">
          <img src="https://img.icons8.com/pulsar-color/96/mind-map.png" alt="MindMap Generation" />
          <h3>Visual Learning</h3>
          <p>Understand complex topics with auto-generated mind maps</p>
        </div>
      </div>
    </div>
  </section>

  <section id="how-it-works" class="how-it-works">
    <div class="container">
      <h2>How SmartReader Works</h2>
      <div class="steps">
        <div class="step">
          <img src="https://img.icons8.com/pulsar-color/96/rss.png" alt="Subscribe" />
          <h3>Subscribe</h3>
          <p>Add your favorite RSS feeds to SmartReader</p>
        </div>
        <div class="step">
          <img src="https://img.icons8.com/pulsar-color/96/artificial-intelligence.png" alt="AI Processing" />
          <h3>AI Processing</h3>
          <p>Our AI filters and analyzes your content</p>
        </div>
        <div class="step">
          <img src="https://img.icons8.com/pulsar-color/96/overview-pages-3.png" alt="Summarize" />
          <h3>Summarize</h3>
          <p>Get concise summaries and visual mind maps</p>
        </div>
        <div class="step">
          <img src="https://img.icons8.com/pulsar-color/96/reading.png" alt="Read" />
          <h3>Read Efficiently</h3>
          <p>Enjoy a personalized, focused reading experience</p>
        </div>
      </div>
    </div>
  </section>

  <section id="testimonials" class="testimonials">
    <div class="container">
      <h2>What Our Users Say</h2>
      <div class="testimonial-grid">
        <div class="testimonial-card">
          <img src="https://img.icons8.com/pulsar-color/96/user-female.png" alt="Sarah K." />
          <p>
            "SmartReader has revolutionized how I consume online content. It's a
            real game-changer!"
          </p>
          <h4>Sarah K.</h4>
          <p>Tech Enthusiast</p>
        </div>
        <div class="testimonial-card">
          <img src="https://img.icons8.com/pulsar-color/96/user-male.png" alt="John D." />
          <p>
            "I save hours each week thanks to the intelligent summaries and mind
            maps."
          </p>
          <h4>John D.</h4>
          <p>Business Analyst</p>
        </div>
        <div class="testimonial-card">
          <img src="https://img.icons8.com/pulsar-color/96/user.png" alt="Emily R." />
          <p>
            "The AI filtering is spot-on. I never miss important articles now!"
          </p>
          <h4>Emily R.</h4>
          <p>Journalist</p>
        </div>
      </div>
    </div>
  </section>

  <section id="pricing" class="pricing">
    <div class="container">
      <h2>Choose Your Plan</h2>
      <div class="pricing-grid">
        <div class="pricing-card">
          <div class="pricing-content">
            <h3>Free</h3>
            <div class="price">$0/mo</div>
            <ul>
              <li>10 RSS feeds</li>
              <li>Advanced AI summarization</li>
              <li>Up to 10 keywords per article</li>
              <li>Ad-free experience</li>
            </ul>
            <a href="#" class="cta-button">Start Free</a>
          </div>
        </div>
        <div class="pricing-card featured">
          <div class="pricing-content">
            <h3>Basic</h3>
            <div class="price">$9.9/mo</div>
            <ul>
              <li>100 RSS feeds</li>
              <li>Advanced AI summarization</li>
              <li>Up to 10 keywords per article</li>
              <li>Mind map generation</li>
              <li>Cross-device sync</li>
              <li>Email support</li>
              <li>Ad-free experience</li>
            </ul>
            <a href="#" class="cta-button" @click="createSubscription('basic')">Choose Basic</a>
          </div>
        </div>
        <div class="pricing-card">
          <div class="pricing-content">
            <h3>Pro</h3>
            <div class="price">$19.9/mo</div>
            <ul>
              <li>250 RSS feeds</li>
              <li>Advanced AI summarization</li>
              <li>Up to 10 keywords per article</li>
              <li>Mind map generation</li>
              <li>Cross-device sync</li>
              <li>Priority email support</li>
              <li>Ad-free experience</li>
            </ul>
            <a href="#" class="cta-button" @click="createSubscription('pro')">Choose Pro</a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <footer>
    <div class="container">
      <div class="footer-links">
        <a href="/privacy">Privacy Policy</a>
        <a href="/terms-of-service">Terms of Service</a>
        <a href="/contact">Contact Me</a>
      </div>
      <p>&copy; 2024 SmartReader. All rights reserved.</p>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import axios from 'axios';
import PageLoading from '~/components/PageLoading.vue';

function goToSignIn() {
  window.location.href = "/signin";
}

const paying = ref(false)

async function createSubscription(plan: string) {
  try {
    paying.value = true
    const response = await axios.get(`/api/stripe/create_session?plan=${plan}`);
    const { url } = response.data
    window.location.href = url;
  } catch (e) {
    console.log(e)
  } finally {
    paying.value = false
  }
}


</script>

<style>
/* 基础样式 */
body {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  margin: 0;
  padding: 0;
  color: #333;
  line-height: 1.6;
}

h3 {
  display: block;
  font-size: 1.17em;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
  unicode-bidi: isolate;
}

h4 {
  display: block;
  margin-block-start: 1.33em;
  margin-block-end: 1.33em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
  unicode-bidi: isolate;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

h2 {
  font-size: 36px;
  text-align: center;
  margin-bottom: 40px;
}

/* 导航栏样式 */
nav {
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
}

nav .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}

nav .logo {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: center;
}

nav .logo img {
  margin-right: 10px;
}

nav .logo span {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

nav ul {
  display: flex;
  list-style: none;
}

nav ul li {
  margin-left: 30px;
}

nav ul li a {
  text-decoration: none;
  color: #333;
  font-weight: 500;
}

.main-cta-button {
  background-color: #4caf50;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  text-decoration: none;
  font-weight: bold;
  max-width: 10rem;
  margin-left: auto;
  margin-right: auto;
}

.main-cta-button .primary-text {
  font-size: 20px;
  font-weight: bold;
}

.main-cta-button .secondary-text {
  font-size: 14px;
  opacity: 0.9;
}

/* 英雄区域样式 */
.hero {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 150px 0 100px;
  text-align: center;
}

.hero h1 {
  font-size: 48px;
  margin-bottom: 20px;
}

.hero p {
  font-size: 20px;
  max-width: 600px;
  margin: 0 auto 30px;
}

/* 特性部分样式 */
.features {
  padding: 100px 0;
  background-color: #f9f9f9;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.feature-card {
  background: white;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.feature-card img {
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
}

/* How It Works 样式 */
.how-it-works {
  padding: 100px 0;
  background-color: #ffffff;
}

.steps {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
}

.step {
  flex-basis: 22%;
  text-align: center;
}

.step img {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
}

/* Testimonials 样式 */
.testimonials {
  padding: 100px 0;
  background-color: #f9f9f9;
}

.testimonial-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.testimonial-card {
  background: white;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.testimonial-card img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-bottom: 20px;
}

/* Pricing 样式 */
.pricing-grid {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.pricing-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #f9f9f9;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 300px;
}

.pricing-content {
  flex-grow: 1;
}

.pricing-card h3 {
  font-size: 24px;
  margin-bottom: 20px;
}

.price {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 20px;
}

.pricing-card ul {
  list-style-type: none;
  padding: 0;
  margin-bottom: 20px;
}

.pricing-card li {
  margin-bottom: 10px;
}

.cta-button {
  display: block;
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  text-align: center;
  text-decoration: none;
  border-radius: 5px;
  font-weight: bold;
  transition: background-color 0.3s;
}

.cta-button:hover {
  background-color: #45a049;
}

.pricing-card.featured {
  transform: scale(1.05);
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);
  border: 2px solid #4caf50;
}

/* Footer 样式 */
footer {
  margin-top: 5rem;
  background-color: #333;
  color: white;
  padding: 50px 0;
  text-align: center;
}

.footer-links {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.footer-links a {
  color: white;
  text-decoration: none;
  margin: 0 15px;
}

.social-icons a {
  color: white;
  font-size: 24px;
  margin: 0 10px;
}
</style>
